import { Analyst } from '@analysis/domain';
import { SampleAiAnalysisStatus } from '@analysis/use-cases';

export const AI_ANALYSIS_SAVE_BLOCKED_I18N = {
  title: 'info.micro_ai_analysis_save_blocked_title',
  body: 'info.micro_ai_analysis_save_blocked_body',
} as const;

/**
 * Algorithm AI is still running, or ended in a terminal error that is
 * resolved operationally (redrive after fixing the cause) — allow
 * visualization only, not review or edit, so a later re-run does not clash
 * with manual work.
 */
export function algorithmAiAnalysisLocked(
  status: SampleAiAnalysisStatus | undefined,
  selectedAnalyst?: Pick<Analyst, 'type'> | null
): boolean {
  return (status === 'inProgress' || status === 'error') && selectedAnalyst?.type === 'algorithm';
}
